import { sharedPalette } from '../styles/colors/constants';

module.exports = {
  COMPLETE_SIGNUP_INSTRUCTION:
    "You're only one step away from commenting on articles, saving images, and participating in our coolest features.",
  LANGUAGE_DICTIONARY: {
    signUpTerms:
      'By signing up, you agree to our <a href="https://www.apartmenttherapy.com/about/terms" target="_blank">terms of service</a> and <a href="https://www.apartmenttherapy.com/about/privacy-policy" target="_blank">privacy policy</a>.',
    signUpTitle:
      'Sign up to comment on articles, save images, and participate in our coolest features.',
    title:
      'Sign in to comment on articles, save images, and participate in our coolest features.'
  },
  THEME: {
    logo:
      'https://cdn.apartmenttherapy.info/image/upload/h_90,q_100/v1555959345/resources/at-logo.png',
    pageBackground:
      'url(https://cdn.apartmenttherapy.info/image/upload/c_fill,h_1080,q_25,w_1920/v1588000533/product/Login%20Page%20BG/AT_2020.jpg)',
    primaryColor: sharedPalette.atRed
  }
};
